import { blockKey } from '@hyphengroup/cms-components/calculatedAttributes/blockKey';

type Block = { __typename?: string; id?: string };

/**
 * The legacy blocks the reader's loan filter has always governed: they read
 * the URL themselves and mount the filter into the shared slot.
 */
const LEGACY_SLOT_BLOCKS = new Set([
  'ComponentPagesComponentComparisonTable',
  'ComponentPagesComponentSelectedProducts',
  'ComponentPagesComponentCardListingPosition',
]);

/**
 * Where the filter has always stopped sticking. Selected Products is a slot
 * block but not an end block — existing behaviour, kept as is.
 */
const LEGACY_RANGE_END_BLOCKS = new Set([
  'ComponentPagesComponentComparisonTable',
  'ComponentPagesComponentCardListingPosition',
]);

/**
 * Whether a block on the page already mounts the reader's filter. Every legacy
 * slot block does — Card Listing as a listener whose node still takes the
 * slot's first place. Where one is present the page-level widget yields.
 */
export const hasLoanFilterHost = (components: Block[]): boolean =>
  components.some((component) =>
    LEGACY_SLOT_BLOCKS.has(component.__typename ?? ''),
  );

/**
 * The blocks the reader's filter moves, by address — the engine's answer, read
 * from the calculation store (`usePageFilterFollowers`).
 */
export type PageFilterFollowers = ReadonlySet<string>;

/** Whether the loan-filter slot is rendered next to this block. */
export const hasLoanFilterSlot = (
  component: Block,
  followers: PageFilterFollowers,
): boolean =>
  LEGACY_SLOT_BLOCKS.has(component.__typename ?? '') ||
  followers.has(blockKey(component));

/** Whether the filter keeps sticking down to this block. */
export const endsLoanFilterRange = (
  component: Block,
  followers: PageFilterFollowers,
): boolean =>
  LEGACY_RANGE_END_BLOCKS.has(component.__typename ?? '') ||
  followers.has(blockKey(component));
